import React, { useState, useEffect } from "react";
import * as url from "../../../helpers/url_helper"
import {
  ListGroup,
  ListGroupItem,
  Card,
  CardBody,
  CardHeader,
  Input,
  Label,
  Button,
} from "reactstrap";

import Add_Website from "../../../Components/Common/CustomModal/Add_Website";
import { useSelector } from "react-redux";
import Loader from "../../../Components/Common/Loader";
import Web_Link_List from "./Website_Component.js/Web_Link_List";
import { useDispatch } from "react-redux";
import { update_Bot_Combine } from "../../../slices/thunks";
import {
  Get_Website_Links,
  reset_create_new_bot_slice,
} from "../../../slices/Create_New_bot/reducer";
import styles  from "./Website.module.css";
import { EventSourcePolyfill } from 'event-source-polyfill';
import {api} from "../../../config";


const Website = () => {
  const create_new_bot_details = useSelector((state) => state.Create_Bot);
  const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
  const dispatch = useDispatch();
  const [web_links, setweb_links] = useState([]);
  const [web_site_map, setweb_site_map] = useState([]);
  const [status, setstatus] = useState('')
  const [progress, setprogress] = useState('')

  useEffect(() => {
    if (create_new_bot_details.Web_Site_List) {
      setweb_links(create_new_bot_details.Web_Site_List);
    }

    if (create_new_bot_details.Site_Map_List?.pages) {
      setweb_site_map(create_new_bot_details.Site_Map_List.pages);
    }
  }, [
    create_new_bot_details.Web_Site_List,
    create_new_bot_details.Site_Map_List,
  ]);


  useEffect(() => {
      setweb_links(BotDetails.Website_Knowledge_Details)
      const selected_links_ = []
      BotDetails.Website_Knowledge_Details.map((ele)=>{
         if(ele.Uploaded_To_VectorDB){
            selected_links_.push(ele)
         }
      })
     
      setseleted_links(selected_links_)
      return () => {
      dispatch(reset_create_new_bot_slice());
    };
  }, [BotDetails])
  



  // useEffect(() => {
  //   dispatch(
  //     Get_Website_Links({
  //       subpages: JSON.parse(JSON.parse(BotDetails.Website_Knowledge_Details))?.map(
  //         (ele) => {
  //           return ele;
  //         }
  //       ),
  //     })
  //   );

    
  // }, [BotDetails]);


    // Intialize Event Source for Chat .

  function isValidJSON(str) {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}

  // Listing Logic .

  useEffect(() => {


      const baseURL =
        window.location.hostname === "localhost"
          ? api.API_URL_LOCAL_HOST
          : api.API_URL;
      const eventSource = new EventSource(
        `${baseURL}${url.knowledge_upload_status}${BotDetails.Bot_ID}`,
      );


        // Your server sends named events → listen for them explicitly
  const onProgress = (e) => {

    try {
      const data = JSON.parse(e.data);
      console.log("upload-progress parsed:", data);
      setprogress(data.progress)
      setstatus(data.status)
      // update UI...
    } catch (_) {
      // sometimes servers send plain text
      console.log("upload-progress (non-JSON):", e.data);
    }
  };

  const onCompleted = (e) => {
    console.log("upload-completed raw:", e.data);
    try {
      const data = JSON.parse(e.data);
      console.log("upload-completed parsed:", data);
      // finalize UI...
    } catch (_) {
      console.log("upload-completed (non-JSON):", e.data);
    }

  };

  eventSource.addEventListener("upload-progress", onProgress);
  eventSource.addEventListener("upload-completed", onCompleted);

      eventSource.onmessage = (event) => {
        console.log("Event Data")
        if(isValidJSON(event.data)){
        const json_data = JSON.parse(event.data);
        console.log(json_data)


      }
      

    

    
    }
  }, [BotDetails.Bot_ID]);



  useEffect(() => {
    if(!create_new_bot_details.loading){
      setprogress('')
      setstatus('')
    }
   
  }, [create_new_bot_details.loading])
  
  

  const [checkedAll, setcheckedAll] = useState(false);

  const [seleted_links, setseleted_links] = useState([]);

  const onClick_Select_all = (e) => {
    setcheckedAll(e.target.checked);

    if (e.target.checked) {
      setseleted_links([...web_links, ...web_site_map]);
      const weblinks_ = web_links.map((ele)=>{
        let temp = JSON.parse(JSON.stringify(ele))
        temp.Uploaded_To_VectorDB = true
        return temp 
      })
       setweb_links(weblinks_)
    } else {
      const weblinks_ = web_links.map((ele)=>{
        let temp = JSON.parse(JSON.stringify(ele))
        temp.Uploaded_To_VectorDB =false
        return temp 
      })
      setweb_links(weblinks_)
      setseleted_links([]);
    }
  };

  const onClick_Bulk_delete = (e) => {
    const temp_weblinks = web_links.filter(
      (link) => !JSON.stringify(seleted_links).includes(link.Url_Link)
    );
    setweb_links(temp_weblinks);

    const temp_site_map = web_site_map.filter(
      (link) => !JSON.stringify(seleted_links).includes(link.Url_Link)
    );
    setweb_site_map(temp_site_map);
    setseleted_links([]);
    setcheckedAll(false);
  };

  const delete_web_links = (url) => {
    const temp_weblinks = web_links.filter((link) => link.Url_Link !== url.Url_Link);
    setweb_links(temp_weblinks);
  };

  const delete_web_site_map = (url) => {
    const temp_site_map = web_site_map.filter((link) => link.url !== url);
    setweb_site_map(temp_site_map);
  };

  const onClick_update_weblinks = () => {
    const web_site_urls = seleted_links.map((link) => link.Url_Link);
    const web_site_map_urls = web_site_map.map((link) => link.url);

 

    let data = new FormData();

    data.append("assistant_id", BotDetails.Assets_ID);
    data.append("Bot_ID", BotDetails.Bot_ID);
    data.append("API_TYPE", "Website");
    data.append(
      "domains",
      JSON.stringify([...web_site_urls, ...web_site_map_urls])
    );

    data.append(
      "Bot_URL_Knowledge",
      JSON.stringify([...web_links, ...web_site_map])
    );

    dispatch(update_Bot_Combine(data));
  };

  const onClick_Select_or_Deselect_particular = (e, url) => {
    let url_temp = JSON.parse(JSON.stringify(url))
    if (e.target.checked) {
      url_temp.Uploaded_To_VectorDB = true
      setseleted_links([...seleted_links, url_temp]);
      setweb_links(()=>{
        return web_links.map((ele)=>{
             if(ele.Url_Link === url_temp.Url_Link){
                    let temp = JSON.parse(JSON.stringify(ele))
                 temp.Uploaded_To_VectorDB = true
                 return temp
             }

             return ele
        })
      })
    } else {
      url_temp.Uploaded_To_VectorDB = false
      const temp_seleted_links = seleted_links.filter(
        (link) => link.Url_Link !== url_temp.Url_Link
      );
      setseleted_links(temp_seleted_links);

      setweb_links(()=>{
        return web_links.map((ele)=>{
             if(ele.Url_Link === url_temp.Url_Link){
                  let temp = JSON.parse(JSON.stringify(ele))
                 temp.Uploaded_To_VectorDB = false
                 return temp
             }

             return ele
        })
      })



    }
  };



  return (
    <>
      <Card>
        <CardHeader>
          <div className="cust_header">
            <span>
              <b>Website</b>
            </span>
             <div>
                {" "}
                {status!="" && <><span>Status:</span> <span>{status}</span> <span>{progress}</span></>}
              </div>
            {!create_new_bot_details.loading && (
              <Button
                disabled={status}
                color="secondary"
                onClick={() => {
                  onClick_update_weblinks();
                }}
              >
                Save
              </Button>
            )}
          </div>
        </CardHeader>
       
        {(create_new_bot_details.loading || status) ? (
          <Loader />
        ) : (
          <CardBody>
            <div className={styles.left_right}>
              <Add_Website status={status} web_links={web_links} setweb_links={setweb_links} />
              
            </div>

            <div className="sada_cs">
              <div>
                <span>
                  <div className="form-check form-check-outline form-check-primary mb-3">
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      id="formCheck13"
                      value={checkedAll}
                      onChange={(e) => {
                        onClick_Select_all(e);
                      }}
                    />
                    <Label className="form-check-label" htmlFor="formCheck13">
                      Select all
                    </Label>
                  </div>
                </span>
                <span onClick={onClick_Bulk_delete} className="red">
                  <i className="ri-delete-bin-line"></i> Delete
                </span>
              </div>
              <div>
                <span>
                  {/* <span>last update</span>
                      <span>YYYY-MM-DD</span> */}
                </span>
                {/* <span>
                  <i className=" ri-refresh-line"></i>
                </span> */}
              </div>
            </div>
            <div className="">
              <ListGroup>
                {web_links.map((ele, i) => {
                  console.log(ele)
                  return (
                    <Web_Link_List
                      id={i}
                      seleted_links={seleted_links}
                      setcheckedAll={setcheckedAll}
                      onClick_Select_or_Deselect_particular={
                        onClick_Select_or_Deselect_particular
                      }
                      delete_web_links={delete_web_links}
                      checkedAll={checkedAll}
                      key={i}
                      ele={ele}
                    />
                  );
                })}
              </ListGroup>

              <ListGroup>
                {web_site_map.map((ele, i) => {
                  return (
                    <Web_Link_List
                      id={i + 1}
                      seleted_links={seleted_links}
                      setcheckedAll={setcheckedAll}
                      onClick_Select_or_Deselect_particular={
                        onClick_Select_or_Deselect_particular
                      }
                      delete_web_links={delete_web_site_map}
                      checkedAll={checkedAll}
                      key={i + 1}
                      ele={ele}
                    />
                  );
                })}
              </ListGroup>
            </div>
          </CardBody>
        )}
      </Card>
    </>
  );
};

export default Website;
